import React from 'react';

import { Portal } from '@bringg-frontend/bringg-web-infra';

import CustomerRating from './customer-rating/customer-rating';

const CustomerRatingPortal = () => <Portal element={<CustomerRating />} nodeId={'customer-rating-react'} />;

export { CustomerRatingPortal };
